import { isTeamsApp } from "../../../constants";

type TeamsRuntimeResult = {
  inTeams: boolean;
  context: any;
};

declare const require: (
  moduleName: string,
) => typeof import("@microsoft/teams-js");

let teamsSdk: typeof import("@microsoft/teams-js") | null = null;
let teamsContext: any = null;
let initializePromise: Promise<TeamsRuntimeResult> | null = null;

export const getTeamsContext = () => teamsContext;

export const initializeTeamsRuntime = async (): Promise<TeamsRuntimeResult> => {
  if (!isTeamsApp) return { inTeams: false, context: null };
  if (initializePromise) return initializePromise;

  initializePromise = Promise.resolve()
    .then(async () => {
      teamsSdk = require("@microsoft/teams-js");
      await teamsSdk.app.initialize();
      teamsContext = await teamsSdk.app.getContext();
      teamsSdk.app.notifySuccess();
      console.log("Teams SDK 初始化成功", teamsContext);

      return { inTeams: true, context: teamsContext };
    })
    .catch((error) => {
      teamsSdk = null;
      teamsContext = null;
      console.error("Teams SDK 初始化失败:", error);
      return { inTeams: false, context: null };
    });

  return initializePromise;
};

export const getTeamsAuthToken = async () => {
  if (!isTeamsApp) return null;

  const result = await initializeTeamsRuntime();
  if (!result.inTeams || !teamsSdk || !teamsSdk.authentication.getAuthToken)
    return null;

  return teamsSdk.authentication.getAuthToken();
};
